import { handleActions } from 'redux-actions';
import { generateKeyNames } from './keyAndPayloadName';
export class BaseReducer {
    constructor(keyStartAndPayloadName) {
        this.buildReducer = this.buildReducer.bind(this);
        this.keyStartAndPayloadName = keyStartAndPayloadName;
        this.initialState = { model: null, isLoading: true, errors: null, loadStarted: false };
    }
    buildReducer() {
        const self = this;
        const keyNames = generateKeyNames(this.keyStartAndPayloadName);
        return handleActions({
            [keyNames.START]: (state) => Object.assign({}, state, Object.assign(Object.assign({}, state), { isLoading: true, loadStarted: true })),
            [keyNames.SUCCESS]: (state, action) => Object.assign({}, state, Object.assign(Object.assign({}, state), { isLoading: false, [this.keyStartAndPayloadName.payloadName]: action.payload })),
            [keyNames.FAILURE]: (state, action) => Object.assign({}, state, Object.assign(Object.assign({}, state), { isLoading: false, errors: action.payload }))
        }, self.initialState);
    }
}
